import {
  dateFormatLabels,
  FILL_TYPES,
  transportationKeys
} from '../../../../../../consts/conditions';
import { v4 } from 'uuid';
import { arithmeticOperatorLabels } from '../../../../../../consts/operators';
import {
  _filterType,
  _filterTypeItem
} from '../../../../../../hooks/transformations/useDefaultTransformation';
import { deepCopy } from '../../../../../../utils/deepCopy';
import { isArray } from 'lodash';
import { checkValueToZero } from '.';

export const unnormalizeTranformation = (data, _id) => {
  function recursiveTraverseReplace(item, parentItem) {
    if (item.expression?.when) {
      return item.expression.when.map(el => recursiveTraverseReplace(el, item));
    } else if (item.and || item.or) {
      const conditionLabel = Object.keys(item).find(el => ['and', 'or'].includes(el));
      const noThenValue =
        !item?.result_value?.input &&
        !item?.result_value?.column_name &&
        !item?.result_value?.datetime &&
        !item?.result_value?.ai_input?.input;
      const isThenString =
        typeof item?.result_value?.input === 'string' ||
        checkValueToZero(item?.result_value?.input);
      const isAi = !!item?.result_value?.ai_input?.input;
      const thenInputType =
        noThenValue && !isThenString
          ? 'null'
          : !!item.result_value?.input || isThenString
            ? 'input'
            : item.result_value?.datetime
              ? 'datetime'
              : isAi
                ? 'ai_input'
                : 'column';

      const noElseValue =
        !parentItem?.expression?.else?.input &&
        !parentItem?.expression?.else?.column_name &&
        !parentItem?.expression?.else?.datetime;
      const isElseString =
        typeof parentItem?.expression?.else?.input === 'string' ||
        checkValueToZero(parentItem?.expression?.else?.input);
      const elseInputType =
        noElseValue && !isElseString
          ? 'null'
          : !!parentItem.expression?.else?.input || isElseString
            ? 'input'
            : parentItem.expression?.else?.datetime
              ? 'datetime'
              : 'column';

      return {
        id: v4(),
        systemId: _id || item.id,
        isParent: true,
        note: data?.note,
        label: transportationKeys.REPLACE,
        type: 'group',
        firstParent: true,
        then: {
          input:
            checkValueToZero(item.result_value?.input) || item.result_value?.input
              ? item.result_value?.input
              : isThenString
                ? ''
                : null,
          column: item.result_value?.column_name,
          null: null,
          datetime: item.result_value?.datetime,
          ai_input: {
            input: item.result_value?.ai_input?.input || '',
            browser_use: item.result_value?.ai_input?.browser_use,
            documents: item.result_value?.ai_input?.documents || [],
            selected_columns: item.result_value?.ai_input?.selected_columns || []
          }
        },
        thenInputType,
        conditionLabel,
        elseInputType,
        elseValue: {
          input:
            checkValueToZero(parentItem?.expression?.else?.input) ||
            parentItem?.expression?.else?.input
              ? parentItem?.expression?.else?.input
              : isElseString
                ? ''
                : null,
          column:
            parentItem?.expression?.else?.column_name ||
            (!parentItem?.expression?.else?.input && parentItem?.expression?.replace_column), // put to the else value , value from replace_column if there is no input value or column_name
          null: null,
          datetime: parentItem?.expression?.else?.datetime || null
        },

        replaceColumn: parentItem?.expression?.replace_column,
        conditions: [...item[conditionLabel].map(el => recursiveTraverseReplace(el))]
      };
    }

    const isString = typeof item?.comparison_value?.input === 'string';
    const _isArray = isArray(item?.comparison_value?.input);
    const isAi = !!item?.comparison_value?.ai_input?.input;
    const noValue =
      !isString &&
      !item?.comparison_value?.column_name &&
      !item?.comparison_value?.datetime &&
      !isAi;
    const inputType =
      noValue && !isString
        ? 'null'
        : !!item.comparison_value?.input || isString
          ? 'input'
          : item.comparison_value?.datetime
            ? 'datetime'
            : isAi
              ? 'ai_input'
              : 'column';

    return {
      id: v4(),
      type: 'item',
      inputType,
      column: item.column_name,
      operator: item.operator,
      function: item.function,
      note: data?.note,
      value: {
        input:
          !_isArray &&
          (checkValueToZero(item.comparison_value?.input) || item.comparison_value?.input
            ? item.comparison_value?.input
            : isString
              ? ''
              : null),
        column: item.comparison_value?.column_name,
        null: null,
        list: _isArray ? item.comparison_value?.input : [],
        datetime: item.comparison_value?.datetime,
        ai_input: {
          input: item.comparison_value?.ai_input?.input || '',
          browser_use: item.comparison_value?.ai_input?.browser_use,
          documents: item.comparison_value?.ai_input?.documents || [],
          selected_columns: item.comparison_value?.ai_input?.selected_columns || []
        }
      }
    };
  }

  function recursiveTraverseFilter(item, key = transportationKeys.FILTER) {
    if (item.action || item.and || item.or) {
      const conditionLabel = Object.keys(item?.expression || item)[0];

      return {
        id: v4(),
        note: data?.note,
        systemId: item.id,
        isParent: true,
        label: key,
        type: 'group',
        firstParent: true,
        conditionLabel,
        conditions: [
          ...(item?.expression || item)[conditionLabel].map(el => recursiveTraverseFilter(el))
        ]
      };
    }

    const isString = typeof item?.comparison_value?.input === 'string';
    const _isArray = isArray(item?.comparison_value?.input);
    const isAi = !!item?.comparison_value?.ai_input?.input;
    const noValue =
      !isString &&
      !item?.comparison_value?.column_name &&
      !item?.comparison_value?.datetime &&
      !isAi;
    const inputType =
      noValue && !isString
        ? 'null'
        : !!item.comparison_value?.input || isString
          ? 'input'
          : item.comparison_value?.datetime
            ? 'datetime'
            : isAi
              ? 'ai_input'
              : 'column';

    return {
      id: v4(),
      type: 'item',
      inputType: inputType,
      column: item.column_name,
      operator: item.operator,
      value: {
        input:
          !_isArray &&
          (checkValueToZero(item.comparison_value?.input) || item.comparison_value?.input
            ? item.comparison_value?.input
            : isString
              ? ''
              : null),
        column: item.comparison_value?.column_name,
        null: null,
        list: _isArray ? item.comparison_value?.input : [],
        datetime: item.comparison_value?.datetime,
        ai_input: {
          input: item.comparison_value?.ai_input?.input || '',
          browser_use: item.comparison_value?.ai_input?.browser_use,
          documents: item.comparison_value?.ai_input?.documents || [],
          selected_columns: item.comparison_value?.ai_input?.selected_columns || []
        }
      }
    };
  }

  function recursiveTraverseSplitColumns(item) {
    if (item.filter || item.and || item.or) {
      const conditionLabel = Object.keys(item.filter || item)[0];
      const isDateTime = item.split_date?.length > 0;

      return {
        id: v4(),
        note: data?.note,
        systemId: item.id,
        isParent: true,
        replaceColumn: item?.column,
        columns: [...(item?.split_inputs || []), ...(item?.split_date || [])],
        label: transportationKeys.SPLIT,
        type: 'group',
        firstParent: true,
        conditionLabel,
        elseInputType: isDateTime ? 'datetime' : 'input',
        conditions: [
          ...(item.filter || item)[conditionLabel].map(el => recursiveTraverseFilter(el))
        ]
      };
    }

    return {
      id: v4(),
      type: 'item',
      inputType: !item.value ? 'null' : 'input',
      column: item.column_name,
      operator: item.operator,
      value: { input: item.value, null: null }
    };
  }

  function recursiveTraverseDateShifting(item) {
    if (item.filter || item.and || item.or) {
      const conditionLabel = Object.keys(item.filter || item)[0];
      return {
        id: v4(),
        note: data?.note,
        systemId: item.id,
        isParent: true,
        columnName: item?.column_name,
        shiftingMethod: item?.shifting_method,
        timePeriod: item?.time_period,
        periodAmount: item?.amount,
        label: transportationKeys.DATE_SHIFTING,
        type: 'group',
        firstParent: true,
        conditionLabel,
        conditions: [
          ...(item.filter || item)[conditionLabel].map(el => recursiveTraverseFilter(el))
        ]
      };
    }

    return {
      id: v4(),
      type: 'item',
      inputType: !item.value ? 'null' : 'input',
      column: item.column_name,
      operator: item.operator,
      value: { input: item.value, null: null }
    };
  }

  function recursiveTraverseDuplicateRows(item) {
    if (item.filter || item.and || item.or) {
      const conditionLabel = Object.keys(item.filter || item)[0];
      return {
        id: v4(),
        systemId: item.id,
        isParent: true,
        replaceColumn: item?.count,
        note: data?.note,
        // columns: item?.count,
        label: transportationKeys.DUPLICATE_ROWS,
        type: 'group',
        firstParent: true,
        conditionLabel,
        conditions: [
          ...(item.filter || item)[conditionLabel].map(el => recursiveTraverseFilter(el))
        ]
      };
    }

    return {
      id: v4(),
      type: 'item',
      inputType: !item.value ? 'null' : 'input',
      column: item.column_name,
      operator: item.operator,
      value: { input: item.value, null: null }
    };
  }

  function recursiveTraverseMath(item) {
    if (item?.expression?.operations || item?.operations) {
      return {
        id: v4(),
        systemId: item.id,
        note: data?.note,
        firstParent: true,
        label: transportationKeys.ARITHMETIC,
        type: 'group',
        then: {
          input: '',
          column: item?.expression?.result_column || '',
          null: null
        },
        thenInputType: 'column',
        conditions: [...(item?.expression || item)?.operations.map(el => recursiveTraverseMath(el))]
      };
    }

    if (item.type === 'operation')
      return {
        id: v4(),
        type: 'item',
        actionItem: 'operator',
        inputType: 'column',
        value: {
          input: '',
          column: arithmeticOperatorLabels[item.name],
          null: null
        }
      };

    return {
      id: v4(),
      type: 'item',
      actionItem: 'condition', // | operator
      inputType: item.type === 'number' ? 'input' : item.type,
      value: {
        input: item.type !== 'column' ? item.name : '',
        column: item.type === 'column' ? item.name : '',
        null: null
      }
    };
  }

  function recursiveTraverseConcatenate(item) {
    if (item?.expression?.operations || item?.operations) {
      return {
        id: v4(),
        systemId: item.id,
        firstParent: true,
        label: transportationKeys.CONCATENATE,
        type: 'group',
        note: data?.note,
        then: {
          input: '',
          column: item?.expression?.result_column || '',
          null: null
        },
        thenInputType: 'column',
        conditions: [
          ...(item?.expression || item)?.operations.map(el => recursiveTraverseConcatenate(el))
        ]
      };
    }

    if (item.type === 'separator')
      return {
        id: v4(),
        type: 'item',
        actionItem: 'operator',
        inputType: 'column',
        value: {
          input: item.name,
          column: item.name,
          null: null
        }
      };

    const isColumn = item.type === 'column';

    return {
      id: v4(),
      type: 'item',
      actionItem: 'condition', // | operator
      inputType: item.type,
      value: {
        input: !isColumn ? item.name : '',
        column: isColumn ? item.name : '',
        null: null
      }
    };
  }

  if (data.action === transportationKeys.REPLACE) {
    return recursiveTraverseReplace(data);
  } else if (data.action === transportationKeys.FILTER) return recursiveTraverseFilter(data);
  else if (data.action === transportationKeys.SUM_IF)
    return recursiveTraverseFilter(data, transportationKeys.SUM_IF);
  else if (data.action === transportationKeys.ABSOLUTE)
    return {
      id: v4(),
      systemId: data.id,
      label: data.action,
      note: data?.note,
      type: 'item',
      inputType: 'column',
      column: data?.expression?.column
    };
  else if (data.action === transportationKeys.NEGATIVE)
    return {
      id: v4(),
      systemId: data.id,
      label: data.action,
      note: data?.note,
      type: 'item',
      inputType: 'column',
      column: data?.expression?.column
    };
  else if (data.action === transportationKeys.ADD_COLUMN)
    return {
      id: v4(),
      systemId: data.id,
      label: data.action,
      note: data?.note,
      type: 'item',
      inputType: 'input',
      column: data?.expression?.result_column,
      replaceColumn: data?.expression?.type,
      value: {
        input: data?.expression?.fill_value,
        null: null,
        column: null
      }
    };
  else if (data.action === transportationKeys.REMOVE_DUPLICATES)
    return {
      id: v4(),
      systemId: data.id,
      label: data.action,
      note: data?.note,
      type: 'item',
      inputType: 'input',
      columns: data?.expression?.columns,
      keep: data?.expression?.keep
    };
  else if (data.action === transportationKeys.SUBSTITUTE)
    return {
      id: v4(),
      systemId: data.id,
      label: data.action,
      type: 'item',
      inputType: 'input',
      note: data?.note,
      then: {
        input: data?.expression?.new_text,
        column: '',
        null: null
      },
      elseValue: {
        input: data?.expression?.old_text,
        column: '',
        null: null
      },
      elseInputType: 'input',
      thenInputType: 'input',
      replaceColumn: data?.expression?.column,
      updateType: !data?.expression?.instance_num ? 'all' : 'input',
      columnsCount: data?.expression?.instance_num || 1
    };
  else if (data.action === transportationKeys.RENAME_COLUMNS) {
    return data?.expression?.renamed_columns?.map(el => ({
      id: v4(),
      systemId: data.id,
      label: data.action,
      type: 'item',
      inputType: 'input',
      column: el?.from,
      note: data?.note,
      value: {
        input: el?.to,
        null: null,
        column: null
      }
    }));
  } else if (data.action === transportationKeys.CHANGE_DATA_TYPES) {
    return data?.expression?.columns?.map(el => ({
      id: v4(),
      label: data.action,
      type: 'item',
      inputType: 'column',
      column: el?.column,
      currentFormats: [
        ...(el?.existing_formats?.map(item => dateFormatLabels[item]) || []),
        ...(el?.manual_formats || [])
      ],
      note: data?.note,
      value: {
        input: null,
        null: null,
        column: el?.type
      }
    }));
  } else if (data.action === transportationKeys.ARITHMETIC) {
    return recursiveTraverseMath(data);
  } else if (data.action === transportationKeys.CONCATENATE) {
    return recursiveTraverseConcatenate(data);
  } else if (data.action === transportationKeys.SPLIT)
    return recursiveTraverseSplitColumns(data?.expression);
  else if (data.action === transportationKeys.DATE_SHIFTING)
    return recursiveTraverseDateShifting(data?.expression);
  else if (data.action === transportationKeys.DUPLICATE_ROWS)
    return recursiveTraverseDuplicateRows(data?.expression);
  else if (data.action === transportationKeys.JOIN) {
    return {
      ...deepCopy(_filterType),
      id: v4(),
      systemId: data.id,
      label: data.action,
      note: data.note,
      // Backend may return 'warning' or 'warn' depending on version/service
      warning: data.warning || data.warn || null,
      inputType: data?.expression?.join_type,
      elseValue: {
        // `extraction_id: null` on the wire means "second table is a
        // lookup"; map back to the in-memory sentinel `0`.
        input:
          data?.expression?.right_table?.extraction_id === null
            ? 0
            : data?.expression?.right_table?.extraction_id,
        column: null,
        null: null
      },
      then: {
        input: data?.expression?.right_table?.table,
        column: null,
        null: null
      },
      columns: [...(data?.expression?.left_table?.left_columns || [])],
      columns2: [...(data?.expression?.right_table?.right_columns || [])],
      conditions: [...(data?.expression?.left_table?.left_on || [])]?.map((el, idx) => ({
        ...deepCopy(_filterTypeItem),
        id: v4(),
        operator: data?.expression?.right_table?.right_on?.[idx],
        column: el,
        fuzzyMatching: data?.expression?.left_table?.fuzzy_join?.[idx]
      }))
    };
  } else if (data.action === transportationKeys.SPLIT_BY_VALUE) {
    return {
      ...deepCopy(_filterType),
      id: v4(),
      systemId: data.id,
      label: data.action,
      replaceColumn: data?.expression?.column,
      note: data?.note,
      numberOfSplits: String(data?.expression?.split_number),
      direction: data?.expression?.direction,
      expandedNewColumns: data?.expression?.expand_to_columns || false,
      columns:
        data?.expression?.new_columns ||
        Array(data?.expression?.split_number || 0).map(_ => null) ||
        [],
      then: {
        input: data?.expression?.separator,
        column: null,
        null: null
      }
    };
  }

  // FILL FORWARD TYPE
  return {
    id: v4(),
    systemId: data.id,
    label: data.action,
    type: 'item',
    note: data?.note,
    inputType: 'column',
    column: data?.columns?.[0],
    operator: data?.expression?.fill_type || FILL_TYPES.UP
  };
};
